
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { BaseProfileDataInterface, ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import { UserRepoInterface } from '@/services/Users/Interfaces';
import DepartmentRepositoryInterface, { DepartmentInterface } from '@/services/Departments/Interfaces';
import { LeavesRepositoryInterface } from '@/services/Calendar/leaves/interfaces';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    PageHeader,
  },
  inject: [
    'profileRepository',
    'userRepository',
    'departmentRepository',
    'leavesRepository',
  ],
})
export default class Approvers extends Vue {
  private userRepository!: UserRepoInterface;
  private departmentRepository!: DepartmentRepositoryInterface;
  private profileRepository!: ProfileRepositoryInterface;
  private leavesRepository!: LeavesRepositoryInterface;
  private selectedApprovers: { [departmentId: string]: { firstApprover: string, secondApprover: string } } = {};
  private validDepartmentApprovers: { [departmentId: string]: boolean } = {};

  private loading: boolean = true;
  private departments: DepartmentInterface[] = [];
  private usersByDepartment: { [departmentId: string]: BaseProfileDataInterface[] } = {};

  public async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    await this.getDepartments();
    await this.getApprovers();
    await this.getUsers();

    this.loading = false;
  }

  private async getDepartments(): Promise<void> {
    this.departments = await this.departmentRepository.getAllDepartments();
    this.departments.forEach((department) => {
      this.selectedApprovers[department._id] = { firstApprover: '', secondApprover: '' };
      this.validDepartmentApprovers[department._id] = false;
    });
  }

  private async getApprovers(): Promise<void> {
    const approvers = await this.leavesRepository.getAllApprovers();

    approvers.forEach((approver) => {
      this.selectedApprovers[approver.departmentId] = {
        firstApprover: approver.firstApprover,
        secondApprover: approver.secondApprover,
      };
      this.validDepartmentApprovers[approver.departmentId] = true;
    });
  }

  private async getUsers(): Promise<void> {
    for (const department of this.departments) {
      const users = await this.userRepository.getUsersByDepartment(department._id);

      if (!users.length) {
        continue;
      }

      const usersProfiles = await this.profileRepository
        .getBaseProfileDataByUsersIds(users.map((user) => String(user.id)));

      for (const user of users) {
        const profile = usersProfiles.find((p) => p.userId === user.id);
        if (!profile) continue;

        if (!this.usersByDepartment[department._id]) {
          this.usersByDepartment[department._id] = [];
        }

        this.usersByDepartment[department._id].push(profile);
      }
    }
  }


  private async saveApprovers(departmentId: string): Promise<void> {
    try {
      await this.leavesRepository.saveApprovers({
        departmentId,
        firstApprover: this.selectedApprovers[departmentId].firstApprover,
        secondApprover: this.selectedApprovers[departmentId].secondApprover,
      });
      this.$successDialog.show('Department approvers saved successfully');
    } catch (e) {
      this.$errorDialog.show(e.response?.message);
    }
  }

  private validateDepartmentApprovers(departmentId: string): void {
    this.validDepartmentApprovers[departmentId] =
      !!this.selectedApprovers[departmentId].firstApprover
      && this.selectedApprovers[departmentId].firstApprover !== this.selectedApprovers[departmentId].secondApprover;
    this.$forceUpdate();
  }
}
